import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import Chevron from 'react-icons/lib/md/chevron-right';
import IconButton from '@material-ui/core/IconButton';
import Plus from 'react-icons/lib/io/plus';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import StudioLooperTrack from './StudioLooperTrack';
import {isGuest} from '../../../../utils/userUtility';
import {customEvent} from "../../../../utils/analyticsUtil";
import {actions, category, DialogTypes, events} from '../../../../constants/enums';
import LessonFilePreviewDialog from "../../../common/lessonInfoDialog/LessonFilePreviewDialog";

@inject('looperStore', 'dialogStore', 'projectStore')
@observer
class StudioLooperDrawer extends Component {
    updateVolume = track => (volume) => {
        this.props.looperStore.changeVolume(track, volume);
    };

    removeTrack = track => () => {
        this.props.looperStore.removeFromLooper(track);
    };

    handleVolumeClick = track => () => {
        this.props.looperStore.changeVolume(track, !track.volume ? track.prevVolume : 0);
    };

    setOpen = () => {
        this.props.looperStore.toggleLooperDrawer();
    }

    openStudioLibrary = () => {
        customEvent(events.CustomEvent, {category: category.Studio, action: actions.OpenDrawer});
        this.props.dialogStore.openDialog(DialogTypes.StudioLibrary);
    }

    render() {
        const {looperStore, projectStore, dialogStore} = this.props;
        return (
            <SwipeableBottomSheet
                shadowTip={false}
                topShadow={false}
                overlay={false}
                onChange={this.setOpen}
                bodyStyle={{
                    backgroundColor: 'transparent',
                    overflow: 'hidden'
                }}
                open={looperStore.showLooperDrawer}
                overflowHeight={40}>
                <div className="m-studio-drawer">
                    <div className="drawer-opener-wrapper" >
                        <IconButton
                            disableRipple={true}
                            onClick={this.setOpen}
                            classes={{root: `drawer-opener ${looperStore.showLooperDrawer ? 'up' : 'down'}`}}>
                            <Chevron />
                        </IconButton>
                    </div>
                    <div className="drawer-popover-wrapper">
                        <div className="drawer-popover">
                            <IconButton disabled={isGuest()} onClick={this.openStudioLibrary} classes={{root: 'track-add-btn'}}>
                                <Plus />
                                <div className={`track-add-text ${isGuest() ? 'disabled' : ''}`}><FormattedMessage id="studio.add" /></div>
                            </IconButton>
                            {!!looperStore.looperTracks.length && <div className="m-looper-tracks">
                                <div className="m-looper-tracks-area">
                                    {looperStore.looperTracks.map(track => (
                                        <StudioLooperTrack
                                            key={track.id}
                                            track={track}
                                            onVolumeChange={this.updateVolume(track)}
                                            onVolumeToggle={this.handleVolumeClick(track)}
                                            onRemove={this.removeTrack(track)}
                                        />
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                {dialogStore.showFilePreviewDialog && <LessonFilePreviewDialog
                    open={dialogStore.showFilePreviewDialog}
                    onClose={dialogStore.closeFilePreviewDialog}
                    file={projectStore.openedFile}
                    video={projectStore.openedVideo}
                    withHeader={false}
                />}
            </SwipeableBottomSheet>
        );
    }
}

export default StudioLooperDrawer;
